import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { visibleWhen: Object }

  connect() {
    this.boundEvaluateVisibility = this.evaluateVisibility.bind(this);
    document.addEventListener("field:changed", this.boundEvaluateVisibility);
    this.evaluateVisibility();
    console.log("Conditional Field Controller connected");
  }

  disconnect() {
    document.removeEventListener("field:changed", this.boundEvaluateVisibility);
  }

  evaluateVisibility(event = null) {
    const dependencies = this.visibleWhenValue || {};
    if (!Object.keys(dependencies).length) return;

    const currentValues = {};
    if (event?.detail) {
      currentValues[event.detail.key] = event.detail.value;
    } else {
      Object.keys(dependencies).forEach(key => {
        const input = document.querySelector(`[name$="[${key}]"]`);
        currentValues[key] = input?.value;
      });
    }

    console.log("conditional Evaluating visibility", {
      visibleWhen: dependencies,
      actualValue: currentValues
    });

    const shouldShow = Object.entries(dependencies).every(([key, expectedValues]) =>
      expectedValues.includes(currentValues[key])
    );

    shouldShow ? this.show() : this.hide();
  }

  show() {
    this.element.classList.remove("d-none");
    requestAnimationFrame(() => this.element.classList.add("fade", "show"));
  }

  hide() {
    this.element.classList.remove("show");
    this.element.addEventListener("transitionend", () => {
      this.element.classList.add("d-none");
    }, { once: true });
  }
}
